<c-modal #staticBackdropModal backdrop="static" size="lg" visible='true' id="staticBackdropModal">
    <c-modal-header>
        <h4 class="modal-title">{{ "Pick Up Detail" }}</h4>
        <button [cModalToggle]="staticBackdropModal.id" cButtonClose (click)="closeModal()" title="Close"></button>
    </c-modal-header>
    <c-modal-body>
        <c-row>
            <form cForm class="animate" (ngSubmit)="savePickUp()" [formGroup]="pickUpDetailForm">
                <c-row>
                    <c-col [md]="3">
                        <label cLabel for="firstName">{{
                            "First Name"
                            }}</label>
                    </c-col>
                    <c-col [md]="8">
                        <input cFormControl formControlName="firstName" name="firstName" type="text" class="form-control" id="firstName" />
                        <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!pickUpDetailForm.controls['firstName'].valid && !pickUpDetailForm.controls['firstName'].untouched">
                            {{ "First name is required" }}
                        </div>
                    </c-col>
                </c-row>
                <c-row>
                  <c-col [md]="3">
                      <label cLabel for="lastName">{{
                          "Last Name"
                          }}</label>
                  </c-col>
                  <c-col [md]="8">
                      <input cFormControl formControlName="lastName" name="lastName" type="text" class="form-control" id="lastName" />
                      <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!pickUpDetailForm.controls['lastName'].valid && !pickUpDetailForm.controls['lastName'].untouched">
                          {{ "Last name is required" }}
                      </div>
                  </c-col>
                </c-row>
                <c-row>
                    <c-col [md]='3'>
                        <label cLabel for="phone">
                            {{"Phone" }}
                        </label>
                    </c-col>
                    <c-col [md]='8'>
                        <input cFormControl formControlName="phone" name="phone" type="text" class="form-control" id="phone" />
                        <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                          *ngIf="pickUpDetailForm.controls['phone'].hasError('required') && !pickUpDetailForm.controls['phone'].untouched">
                            {{ "Phone is required." }}
                        </div>
                    </c-col>
                </c-row>
                <c-row>
                  <c-col [md]='3'>
                      <label cLabel for="address">
                          {{"Address" }}
                      </label>
                  </c-col>
                  <c-col [md]='8'>
                      <input cFormControl formControlName="address" name="address" type="address" class="form-control" id="address" />
                      <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                        *ngIf="pickUpDetailForm.controls['address'].hasError('required') && !pickUpDetailForm.controls['address'].untouched">
                          {{ "Email is required." }}
                      </div>
                  </c-col>
                </c-row>

                <!-- Date & Time Contact -->
                <c-row>
                  <c-col [md]='3'>
                      <label cLabel for="date">
                          {{"Date & Time" }}
                      </label>
                  </c-col>
                  <c-col [md]='4'>
                      <input cFormControl formControlName="date" name="date" type="date" class="form-control" id="date" title="Pick Up Date"/>
                      <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                        *ngIf="pickUpDetailForm.controls['date'].hasError('required') && !pickUpDetailForm.controls['date'].untouched">
                          {{ "Pick up date is required." }}
                      </div>
                  </c-col>
                  <c-col [md]='4'>
                    <input cFormControl formControlName="time" name="time" type="time" class="form-control" id="time" title="Pick Up Time"/>
                    <div class="alert alert-danger my-1 p-2 fadeInDown animated"
                      *ngIf="pickUpDetailForm.controls['time'].hasError('required') && !pickUpDetailForm.controls['time'].untouched">
                        {{ "Pick up time is required." }}
                    </div>
                  </c-col>
                </c-row>

                <c-row>
                    <c-col [md]='3'></c-col>
                    <c-col [md]='8'>
                      <button type="submit" [disabled]="!pickUpDetailForm.valid" class="btn btn-primary primary w-100">
                          <i class="fa fa-circle-o-notch fa-spin" [hidden]="!isSavingPickUp"></i>
                          <c-spinner [hidden]="!isSavingPickUp"></c-spinner>{{ "Submit" }}
                      </button>
                    </c-col>
                </c-row>
            </form>
        </c-row>
    </c-modal-body>
</c-modal>
